/**
 * Spec 008: helper externo para convertir el `qrContent` (string JSON que arma
 * `domain/delivery.buildQrPayload`) en un data URI listo para meter en un `<img>`.
 *
 * Lo extraje de ShippingLabel.vue porque:
 *  - El watch async generaba un race condition con `PrintShippingLabels.print()`:
 *    setear `labels` + `nextTick` ya disparaba `printd` antes de que la promesa de
 *    `qrcode.toString` resolviera.
 *  - Testeable como función pura sin necesidad de montar Vue.
 *  - Reusable en cualquier preview que necesite el QR (form, mobile, etc).
 *
 * Devuelve null si el input es vacío o si la librería tira (logs a consola).
 */
import QRCode from 'qrcode'

export async function qrContentToSvgDataUri(content) {
  if (!content) return null
  try {
    const svgString = await QRCode.toString(content, { type: 'svg', errorCorrectionLevel: 'L', margin: 0 })
    return `data:image/svg+xml;utf8,${encodeURIComponent(svgString)}`
  } catch (err) {
    console.error('Error generating QR code:', err)
    return null
  }
}

/**
 * Variante batch: aplica `qrContentToSvgDataUri` a un array de objetos y devuelve
 * un nuevo array con la propiedad `qrSvg` agregada. Pensado para que
 * `PrintShippingLabels.print()` espere a que TODOS los QRs estén resueltos antes
 * de meterlos al DOM.
 */
export async function withQrSvg(labels) {
  if (!Array.isArray(labels) || labels.length === 0) return []
  return Promise.all(labels.map(async (label) => ({
    ...label,
    qrSvg: await qrContentToSvgDataUri(label.qrContent)
  })))
}